import { defineStore } from 'pinia'

const TOTAL_SECONDS = 5 * 60
const STORAGE_KEY = 'playback_timer_end'

export const useTimerStore = defineStore('timer', {
  state: () => ({
    remaining: TOTAL_SECONDS,
    _timer: null
  }),

  getters: {
    displayMinutes: (state) => String(Math.floor(state.remaining / 60)).padStart(2, '0'),
    displaySeconds: (state) => String(state.remaining % 60).padStart(2, '0')
  },

  actions: {
    start() {
      if (this._timer) return

      const stored = localStorage.getItem(STORAGE_KEY)
      let endTime = stored ? Number(stored) : 0

      if (!endTime || endTime <= Date.now()) {
        endTime = this._createCountdown()
      }

      this.remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000))

      this._timer = setInterval(() => {
        const diff = Math.ceil((endTime - Date.now()) / 1000)
        if (diff <= 0) {
          endTime = this._createCountdown()
          this.remaining = TOTAL_SECONDS
        } else {
          this.remaining = diff
        }
      }, 1000)
    },

    _createCountdown() {
      const endTime = Date.now() + TOTAL_SECONDS * 1000
      localStorage.setItem(STORAGE_KEY, String(endTime))
      return endTime
    }
  }
})
